import { defineStore, acceptHMRUpdate } from "pinia";
import { brogglBack } from "../axios.js";
// import { useAuthStore } from './auth'
import router from "../router/index.js";
// import { useEntriesStore } from './entries'
import { useFormStore } from "./form.js";
import { useUserStore } from "./user.js";
import { useEntriesStore } from "./entries.js";
import { useProductStore } from "./product.js";
import dayjs from "dayjs";
import { get } from "lodash";

export const useClientStore = defineStore("client", {
  state: () => ({
    client: {},
    clientProfitability: {},
    config: "",
    timerMode: "Normal",
    favorited: false,
    isLoaded: false,
    entities: [],
    name: "",
    configuration: "",
    sumARR: 0,
    loadedDashboard: false,
    searchRes: {},
    searchInput: "",
    usageByEntities: {},
    isReactiveRoutineDone: true,
    clientsDashboardIsLoaded: true,
    clientsProfitabilityDashboard: [],
    clientProfitabilityAggregateTotal: {},
    clientProfitabilityAggregateAverage: {},
    contractProfitability: [],
    contractEcoOverrun: [],
    includeChurnedAccounts: false,
    contractsForClient: [],
    currContractId: 0,
    contractsOverrun: []
  }),
  getters: {
    getClient: (state) => {
      return state.client;
    },
    getClientProfitability: (state) => {
      return state.clientProfitability;
    },
    getConfig: (state) => {
      return state.config;
    },
    getTimerMode: (state) => {
      return state.timerMode;
    },
    getFavorited: (state) => {
      return state.favorited;
    },
    getEntities: (state) => {
      return state.entities;
    },
    getHomeEntries: (state) => {
      return state.homeEntries;
    },
    getDashboard: (state) => {
      return state.dashboard;
    },
    getName: (state) => {
      return state.name;
    },
    getConfiguration: (state) => {
      return state.configuration;
    },
    getSumARR: (state) => {
      return state.sumARR;
    },
    getLoadedDashboard: (state) => {
      return state.loadedDashboard;
    },
    getUsageByEntities: (state) => {
      return state.usageByEntities;
    },
    getIsReactiveRoutineDone: (state) => {
      return state.isReactiveRoutineDone;
    },
    getClientsDashboardIsLoaded: (state) => {
      return state.clientsDashboardIsLoaded;
    },
    getClientsProfitabilityDashboard: (state) => {
      return state.clientsProfitabilityDashboard;
    },
    getClientProfitabilityAggregateTotal: (state) => {
      return state.clientProfitabilityAggregateTotal
    },
    getClientProfitabilityAggregateAverage: (state) => {
      return state.clientProfitabilityAggregateAverage
    },
    getContractProfitability: (state) => {
      return state.contractProfitability;
    },
    getContractEcoOverrun: (state) => {
      return state.contractEcoOverrun;
    },
    getIncludeChurnedAccounts: (state) => {
      return state.includeChurnedAccounts;
    },
    getContractsForClient: (state) => {
      return state.contractsForClient;
    },
    getCurrContractId: (state) => {
      return state.currContractId;
    },
    getContractsOverrun: (state) => {
      return state.contractsOverrun
    }
  },
  actions: {
    async fetchClient() {
      const userStore = useUserStore();
      this.loading = false;
      this.client = null;
      let userId = userStore.getUserId();
      try {
        const res = await brogglBack.get(
          "/client/" + router.currentRoute.value.params.id,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        this.client = res.data.data.client;
        const resOpps = await brogglBack.get("/contract/" + this.client.ID, {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        this.contractsForClient = resOpps.data.data;
        this.contractsForClient.sort((a, b) => {
          if (a.IsLatestOngoingContract === b.IsLatestOngoingContract) {
            return dayjs(b.StartDate) - dayjs(a.StartDate);
          }
        });
        this.contractsForClient.forEach((contract) => {
          if (contract.IsLatestOngoingContract) {
            this.currContractId = contract.ID;
          }
        });
        if (this.currContractId === 0) {
          this.currContractId = this.contractsForClient[0].ID;
        }
        //this.currContractId =
        const resDashboard = await brogglBack.get(
          "/client/dashboard/" + this.client.ID + "/" + this.currContractId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        this.configuration = resDashboard.data.config;
        if (this.config === "TE") {
          this.timerMode = "Timer";
        } else if (this.config === "CSM" || this.config === "Other") {
          this.timerMode = "Normal";
        }
        const resProfitability = await brogglBack.get(
          "/client-profitability/contract/" + this.currContractId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        this.clientProfitability = resProfitability.data.data;

        const resFavorites = await brogglBack.get("/favorite/exists", {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          params: { clientId: this.client.ID, userId: userId },
        });
        this.favorited = resFavorites.data.data;
        const resEntities = await brogglBack.get("/entities", {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          params: { clientId: this.client.ID },
        });
        this.entities = resEntities.data.data;
        this.fetchUsageByEntities();
        this.isLoaded = true;
      } catch (err) {
        this.isLoaded = false;
        console.log(err);
      }
    },
    async forceToFetchClient(clientId) {
      this.loading = false;
      this.client = null;
      try {
        const res = await brogglBack.get("/client", {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          params: { id: clientId },
        });
        return response.data.data.client;
      } catch (err) {
        this.isLoaded = false;
        console.log(err);
      }
    },
    switchMode() {
      if (this.timerMode === "Timer") {
        this.timerMode = "Normal";
      } else if (this.timerMode === "Normal") {
        this.timerMode = "Timer";
      }
    },
    addToFavorite() {
      const userStore = useUserStore();
      let userId = userStore.getUserId();
      try {
        brogglBack
          .post("/favorite/add", 
            {
              userId: userId, 
              clientId: this.client.ID 
            },
            {
              headers: { Authorization: "Bearer " + window.$cookies.get("jwt") }
            }
          )
          .then(() => {
            this.fetchClient();
            this.loading = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    removeFromFavorite() {
      const userStore = useUserStore();
      let userId = userStore.getUserId();
      try {
        brogglBack
          .delete("/favorite/remove", {
            params: { userId: userId, clientId: this.client.ID },
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          })
          .then(() => {
            this.fetchClient();
          });
      } catch (err) {
        console.log(err);
      }
    },
    configLayout() {
      if (this.configuration === "TE") {
        this.timerMode = "Timer";
      } else if (this.configuration === "CSM") {
        this.timerMode = "Normal";
      } else {
        this.timerMode = "Normal";
      }
    },
    isClientOngoing(client) {
      if (client.Status === "Ongoing" || client.Status === "Waiting to start") {
        return false;
      }
      return true;
    },
    isClientStarting(client) {
      if (client.Status === "Wainting to start") {
        return true;
      }
    },
    // async clientSearch() {
    //   try {
    //     if (this.includeChurnedAccounts === false) {
    //       this.includeChurnedAccounts = 0;
    //     }
    //     if (this.searchInput !== "") {
    //       const res = await brogglBack.get(
    //         "/client/search/" + this.searchInput,
    //         {
    //           headers: {
    //             Authorization: "Bearer " + window.$cookies.get("jwt"),
    //           },
    //           params: { includeChurnedAccounts: this.includeChurnedAccounts },
    //         },
    //       );
    //       this.searchRes = res.data.data;
    //     } else {
    //       this.searchRes = {};
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    async clientSearch () {
      try {
        if (this.searchInput !== '') {
          const res = await brogglBack.get('/client/v1/search', {headers: {Authorization: "Bearer " + window.$cookies.get('jwt')}, params: {query: this.searchInput, includeChurnedAccounts: this.includeChurnedAccounts}})
          this.searchRes = res.data.data
        }
        else {
          this.searchRes = {}
        }
      } catch (err) {
        console.log(err)
      }
    },

    async fetchEntities(clientId) {
      try {
        const res = await brogglBack.get("/entities", {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          params: { clientId: clientId },
        });
        this.entities = res.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchUsageByEntities() {
      try {
        let res = {};
        if (
          this.currContractId !== this.contractsForClient[0].ID &&
          this.currContractId !== 0
        ) {
          res = await brogglBack.get(
            "/client/entities/usage/" + router.currentRoute.value.params.id,
            {
              headers: {
                Authorization: "Bearer " + window.$cookies.get("jwt"),
              },
              params: { oppId: this.currContractId },
            },
          );
        } else {
          res = await brogglBack.get(
            "/client/entities/usage/" + router.currentRoute.value.params.id,
            {
              headers: {
                Authorization: "Bearer " + window.$cookies.get("jwt"),
              },
            },
          );
        }
        this.usageByEntities = res.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    getClientId() {
      if (Object.keys(this.client).length === 0) {
        return router.currentRoute.value.params.id;
      } else {
        return this.client.ID;
      }
    },
    clearClientStore() {
      this.client = {};
      this.entities = [];
      this.usageByEntities = {};
    },
    setScopeDependingOnClient(viewOrigin) {
      const formStore = useFormStore();
      if (viewOrigin === "client" && this.client.Status === "Ongoing") {
        formStore.parameters.scope = "n/a";
      }
    },
    async clientReactivnessRoutine() {
      this.isReactiveRoutineDone = false;
      const userStore = useUserStore();
      const entriesStore = useEntriesStore();
      const productStore = useProductStore();
      const formStore = useFormStore();
      this.loading = false;
      try {
        await entriesStore.fetchEntries();
        await productStore.fetchProducts();
        const resDashboard = await brogglBack.get(
          "/client/dashboard/" + this.client.ID + "/" + this.currContractId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        this.configuration = resDashboard.data.config;
        if (this.config === "TE") {
          this.timerMode = "Timer";
        } else if (this.config === "CSM" || this.config === "Other") {
          this.timerMode = "Normal";
        }
        const resProfitability = await brogglBack.get(
          "/client-profitability/contract/" + this.currContractId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        this.clientProfitability = resProfitability.data.data;
        await entriesStore.fetchClientDashboard();
        await entriesStore.fetchOfferedCampaigns();
        await entriesStore.fetchOfferedAnalysis();
        const resEntities = await brogglBack.get("/entities", {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          params: { clientId: this.client.ID },
        });
        this.entities = resEntities.data.data;
        await this.fetchUsageByEntities();
        formStore.parameters.client = this.client.ID;
        this.isReactiveRoutineDone = true;
      } catch (err) {
        this.isLoaded = false;
        console.log(err);
      }
    },
    async clientsDashbordCSVExport() {
      var data, filename, link;
      this.clientsDashboardIsLoaded = false;
      data = await brogglBack.get("/clients/dashboard", {
        headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
      });
      let args = data.data;
      var csv = this.convertClientsDahsboardJSONToCSV({ args });
      if (csv == null) return;
      // getCurrentDate
      var date = new Date();
      filename = "export-clients-dashboard_" + date + ".csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      this.clientsDashboardIsLoaded = true;
    },
    convertClientsDahsboardJSONToCSV(args) {
      var result, columnDelimiter, lineDelimiter, data;
      let clientsDashboard = args.args.data;
      columnDelimiter = ",";
      lineDelimiter = "\n";
      result = "";
      result =
        "Client name" +
        columnDelimiter +
        "start date" +
        columnDelimiter +
        "end date" +
        columnDelimiter +
        "ask TSE hours average" +
        columnDelimiter +
        "ask TSE hours total" +
        columnDelimiter +
        "basic technical support hours average " +
        columnDelimiter +
        "basic technical support hours total" +
        columnDelimiter +
        "customer success hours average" +
        columnDelimiter +
        "customer success hours total" +
        columnDelimiter +
        "suppor hours average" +
        columnDelimiter +
        "support hours total" +
        columnDelimiter +
        "professional services average" +
        columnDelimiter +
        "professional services hours total" +
        columnDelimiter +
        "onboarding average" +
        columnDelimiter +
        "onboarding hours total" +
        columnDelimiter +
        "product used" +
        columnDelimiter +
        "product contracted" +
        columnDelimiter +
        lineDelimiter;
      Object.keys(clientsDashboard).forEach((key) => {
        result +=
          key +
          columnDelimiter +
          clientsDashboard[key]["start_date"] +
          columnDelimiter +
          clientsDashboard[key]["end_date"] +
          columnDelimiter +
          clientsDashboard[key]["askTSEHours"]["customerSupportAverage"] +
          columnDelimiter +
          clientsDashboard[key]["askTSEHours"]["hours"] +
          columnDelimiter +
          clientsDashboard[key]["basicTechnicalSupportHours"][
            "basicSupportAverage"
          ] +
          columnDelimiter +
          clientsDashboard[key]["basicTechnicalSupportHours"]["hours"] +
          columnDelimiter +
          clientsDashboard[key]["customerSupportHours"][
            "customerSupportAverage"
          ] +
          columnDelimiter +
          clientsDashboard[key]["customerSupportHours"]["hours"] +
          columnDelimiter +
          clientsDashboard[key]["supportHours"]["supportAverage"] +
          columnDelimiter +
          clientsDashboard[key]["supportHours"]["hours"] +
          columnDelimiter +
          clientsDashboard[key]["professionalServices"]["psAverage"] +
          columnDelimiter +
          clientsDashboard[key]["professionalServices"]["hours"] +
          columnDelimiter +
          clientsDashboard[key]["onboarding"]["onboardingAverage"] +
          columnDelimiter +
          clientsDashboard[key]["onboarding"]["hours"] +
          columnDelimiter +
          clientsDashboard[key]["productClient"]["totalUsed"] +
          columnDelimiter +
          clientsDashboard[key]["productClient"]["totalContracted"] +
          lineDelimiter;
      });
      return result;
    },
    async launchBrogglClientSyncWithSFDC() {
      try {
        this.isReactiveRoutineDone = false;
        await brogglBack.post("/salesforce/sync-client", {
          clientId: this.client.ID,
        });
        await this.fetchClient();
        await this.clientReactivnessRoutine();
      } catch (err) {
        console.log(err);
      }
    },
    async fetchClientsProfitabilityDashboard() {
      try {
        const res = await brogglBack.get("/clients-profitabilities-dashboard", {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        this.clientsProfitabilityDashboard = res.data.data.clientProfitability;
        this.clientProfitabilityAggregateTotal = res.data.data.aggregate.total;
        this.clientProfitabilityAggregateAverage = res.data.data.aggregate.avg;

      } catch (err) {
        console.log(err);
      }
    },
    async fetchContractProfitability(sfClientId, clientId) {
      if (sfClientId === undefined || sfClientId === null) {
        sfClientId = await this.fetchSfdcClientId(clientId);
      }
      try {
        const res = await brogglBack.get(
          "/client-profitability/client/" + sfClientId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        this.contractProfitability = res.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchContractEco(sfClientId, clientId) {
      if (sfClientId === undefined || sfClientId === null) {
        sfClientId = await this.fetchSfdcClientId(clientId);
      }
      try {
        const res = await brogglBack.get(
          "/client-profitability/eco-overrun/" + sfClientId,
          {
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          },
        );
        this.contractEcoOverrun = res.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchContractsOverrun() {
      try {
        const contractOver = await brogglBack.get("/client-profitability/eco-overrun", {
          headers: {Authorization: "Bearer " + window.$cookies.get("jwt") }
        })
        this.contractsOverrun = contractOver.data.data
      } catch (err) {
        console.log(err)
      }
    },
    async fetchSfdcClientId(clientId) {
      try {
        const res = await brogglBack.get("/client/" + clientId, {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        return res.data.data.client.SFAccountId;
      } catch (err) {
        console.log(err);
      }
    },
    csvExportClientProfitabilityDashboard(clientsProfitabilityDashboard) {
      var data, filename, link;
      data = clientsProfitabilityDashboard;
      var csv = this.convertClientsProfitabilityDashboardJSONToCSV({ data });
      if (csv == null) return;
      // getCurrentDate
      var date = new Date();
      filename = "export-clients-profitability-dashboard_" + date + ".csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    convertClientsProfitabilityDashboardJSONToCSV(args) {
      var result, columnDelimiter, lineDelimiter, data;
      let clientsProfitabilityDashboard = args.data;
      columnDelimiter = ",";
      lineDelimiter = "\n";
      result = "";
      result =
        "Client Name" +
        columnDelimiter +
        "CSM" +
        columnDelimiter +
        "POD" +
        columnDelimiter +
        "CSM Office" +
        columnDelimiter +
        "KAM" +
        columnDelimiter +
        "Start Date" +
        columnDelimiter +
        "End Date" +
        columnDelimiter +
        "Man-days Contracted" +
        columnDelimiter +
        "Man-days Contracted per month" +
        columnDelimiter +
        "Contract term (months)" +
        columnDelimiter +
        "Months left in the contract" +
        columnDelimiter +
        "Currency (local)" +
        columnDelimiter +
        "License Total Price (Local)" +
        columnDelimiter +
        "License Total Price (EUR)" +
        columnDelimiter +
        "10% of License Total Price" +
        columnDelimiter +
        "10% License per month" +
        columnDelimiter +
        "CS Plan" +
        columnDelimiter +
        "Total CSM Budget" +
        columnDelimiter +
        "Total CSM Budget per month";
      result +=
        columnDelimiter +
        "Available FTE CSM per month(days)" +
        columnDelimiter +
        "Available FTE CSM since beg of contract(days)" +
        columnDelimiter +
        "CS 10% Man-days Contracted" +
        columnDelimiter +
        "CS 10% Man-days Contracted per months" +
        columnDelimiter +
        "CS Available 10% Man-days Contracted since beg of contract" +
        columnDelimiter +
        "CS Total time available since beg of contract" +
        columnDelimiter +
        "CS time spent since beg of contract (days)" +
        columnDelimiter +
        "CS Time spent vs available FTE" +
        columnDelimiter +
        "PS 90% Man-days Contracted" +
        columnDelimiter +
        "PS 90% Man-days Contracted per months (days)" +
        columnDelimiter +
        "PS Available 90% Man-days Contracted since beg of contract (days)";
      result +=
        columnDelimiter +
        "PS time spent since beg of contract (days)" +
        columnDelimiter +
        "PS Time spent vs available Man-days" +
        columnDelimiter +
        "Man-days Used" +
        columnDelimiter +
        "Man-days available since beg of contract" +
        columnDelimiter +
        "Man-days Used vs Available" +
        columnDelimiter +
        "Man-days Left" +
        columnDelimiter +
        "Man-days left per month" +
        columnDelimiter +
        "Estimated MUVs" +
        columnDelimiter +
        "UVs since Opport Start Date" +
        columnDelimiter +
        "Average MUVs since Opport Start Date" +
        columnDelimiter +
        "Average MUVs vs Estimated MUVs" +
        columnDelimiter +
        "% of UVs used" +
        columnDelimiter +
        "% of Time into the contract" +
        columnDelimiter +
        "% of Time into the opportunity" +
        columnDelimiter +
        "SF ID" +
        columnDelimiter +
        "Estimated Cost Overrun CS Time" +
        columnDelimiter +
        "Estimated Cost Overrun PS Time" +
        columnDelimiter +
        "MUV Resource Usage" +
        columnDelimiter +
        "Estimated Cost Overrun Total" +
        columnDelimiter +
        "Months Into The Contract" +
        columnDelimiter +
        "Total Annualissed Cost Overrun" +
        lineDelimiter;
      Object.keys(clientsProfitabilityDashboard).forEach((data) => {
        result +=
          clientsProfitabilityDashboard[data].Name +
          columnDelimiter +
          clientsProfitabilityDashboard[data].CSMName +
          columnDelimiter +
          clientsProfitabilityDashboard[data].Pod +
          columnDelimiter +
          clientsProfitabilityDashboard[data].CSMOffice +
          columnDelimiter +
          clientsProfitabilityDashboard[data].KAMName +
          columnDelimiter +
          clientsProfitabilityDashboard[data].StartDate +
          columnDelimiter +
          clientsProfitabilityDashboard[data].EndDate +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ManDaysContracted +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ManDaysContractedPerMonth +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ContractTerm +
          columnDelimiter +
          clientsProfitabilityDashboard[data].MonthsLeftInContract +
          columnDelimiter +
          clientsProfitabilityDashboard[data].Currency +
          columnDelimiter +
          clientsProfitabilityDashboard[data].LicenseTotalPriceLocal +
          columnDelimiter +
          clientsProfitabilityDashboard[data].LicenseTotalPrice +
          columnDelimiter +
          clientsProfitabilityDashboard[data].TenPercentOfLicenseTotalPrice +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .TenPercentOfLicenseTotalPricePerMonth +
          columnDelimiter +
          clientsProfitabilityDashboard[data].CSPlanPrice +
          columnDelimiter +
          clientsProfitabilityDashboard[data].TotalCSMBudget +
          columnDelimiter +
          clientsProfitabilityDashboard[data].TotalCSMBudgetPerMonth +
          columnDelimiter +
          clientsProfitabilityDashboard[data].AvailableFTECSMPerMonth +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .AvailableFTECSMSinceContractStart +
          columnDelimiter +
          clientsProfitabilityDashboard[data].CSTenPercentManDaysContracted +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .CSTenPercentManDaysContractedPerMonth +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .CSTenPercentManDaysContractedSinceContractStart +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .CSTotalTimeAvailableSinceContractStart;
        result +=
          columnDelimiter +
          clientsProfitabilityDashboard[data].CSTotalTimeSpentSince +
          columnDelimiter +
          clientsProfitabilityDashboard[data].CSTimeSpentVSAvailableFTECSM +
          columnDelimiter +
          clientsProfitabilityDashboard[data].PSNinetyPercentManDaysContracted +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .PSNinetyPercentManDaysContractedPerMonth +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .PSNinetyPercentManDaysContractedSinceContractStart +
          columnDelimiter +
          clientsProfitabilityDashboard[data].PSTimeSpentSinceContractStart +
          columnDelimiter +
          clientsProfitabilityDashboard[data].PsTimeSpentVSAvailableFTE +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ManDaysUsed +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .ManDaysAvailableSinceContractStart +
          columnDelimiter +
          clientsProfitabilityDashboard[data]
            .ManDaysUsedVSAvailableTimeIntoContract +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ManDaysLeft +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ManDaysLeftPerMonth +
          columnDelimiter +
          clientsProfitabilityDashboard[data].EstimatedMUVs +
          columnDelimiter +
          clientsProfitabilityDashboard[data].UVsSinceLastOpportunity +
          columnDelimiter +
          clientsProfitabilityDashboard[data].AverageMUVsSinceLastOpportunity +
          columnDelimiter +
          clientsProfitabilityDashboard[data].AverageMUVsVSEstimatedMUVs +
          columnDelimiter +
          clientsProfitabilityDashboard[data].PercentageOfUVsUsed +
          columnDelimiter +
          clientsProfitabilityDashboard[data].PercentageIntoContract +
          columnDelimiter +
          clientsProfitabilityDashboard[data].PercentageIntoTheOpportunity +
          columnDelimiter +
          clientsProfitabilityDashboard[data].SFAccountId +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ECOCSMTime +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ECOPSTime +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ECOMUVResourceUsage +
          columnDelimiter +
          clientsProfitabilityDashboard[data].ECOTotal +
          columnDelimiter +
          clientsProfitabilityDashboard[data].MonthsIntoTheContract +
          columnDelimiter +
          clientsProfitabilityDashboard[data].TotalAnnualisedCostOverrun +
          lineDelimiter;
      });
      return result;
    },
    getCurrSfOppId() {
      let result = "";
      this.contractsForClient.forEach((opportunity) => {
        if (opportunity.ID === this.currContractId) {
          result = opportunity.SfContractId;
        }
      });
      return result;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useClientStore, import.meta.hot));
}
